import React, { useEffect, useRef, useState } from "react";
import './AdCard.css';

import { toggleFavorite } from "../api/favoritesApi";
import axios from "../axios";
import { API_BASE_URL } from "../config";

const AdCard = ({ ad, highlight, highlightRef }) => {    
  const cardRef = useRef(null);
  const sentImpressionRef = useRef(false);
    // локальное состояние: в избранном ли объявление
  const [isFavorite, setIsFavorite] = useState(!!ad.is_favorite);
    // берём первую картинку из объявления
  const first = ad?.images?.[0]?.image;

  // делаем абсолютный URL, если пришёл относительный (/media/...)
  const normalize = (url) => {
    if (!url) return null;
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    return `${API_BASE_URL}${url}`;
  };

  // итоговый src + локальная заглушка
  const imgSrc = normalize(first) || '/no-image.png';
  const [imgLoaded, setImgLoaded] = useState(false);

  useEffect(() => {
    if (!cardRef.current) return;

    const observer = new IntersectionObserver(
      async (entries) => {
        const entry = entries[0];
        if (!entry?.isIntersecting) return;

        // чтобы 1 раз считалось за этот рендер списка
        if (sentImpressionRef.current) return;
        sentImpressionRef.current = true;

        try {
          await axios.post(`/api/ads/${ad.id}/track/`, { event: "impression" });
        } catch (e) {
          // не мешаем пользователю, просто лог
          console.log("impression track error", e);
        }

        observer.disconnect();
      },
      {
        threshold: 0.5, // 50% карточки видно — считаем показ
      }
    );

    observer.observe(cardRef.current);

    return () => observer.disconnect();
  }, [ad.id]);

  const handleToggleFavorite = async (e) => {
    // чтобы клик по сердцу НЕ открывал подробности объявления
    e.stopPropagation();

    const token = localStorage.getItem("token");
    if (!token) {
      window.dispatchEvent(
        new CustomEvent("open-login-modal", {
          detail: { message: "Παρακαλώ συνδεθείτε για να προσθέσετε στα αγαπημένα" },
        })
      );
      return;
    }

    if (!ad?.id) return;

    // 🔥 1) Мгновенно меняем UI
    setIsFavorite((prev) => !prev);

    try {
      // 🔥 2) Переключаем избранное на сервере
      const res = await toggleFavorite(ad.id); // { is_favorite: true/false }

      // ✅ 3) Синхронизируем UI с тем, что реально на сервере
      if (typeof res?.is_favorite === "boolean") {
        setIsFavorite(res.is_favorite);
      }

    } catch (error) {
      console.error("Σφάλμα αλλαγής αγαπημένου:", error);

      // откат UI
      setIsFavorite((prev) => !prev);
      alert("Σφάλμα αλλαγής αγαπημένου.");
    }
  };
  
return (
  <div
    ref={(el) => {
      cardRef.current = el;
      if (highlightRef && el) highlightRef.current = el;
    }}
    className={`ad-card ${highlight ? "ad-card-highlight" : ""}`}
    onClick={() => {
      window.open(`/ads/${ad.id}`, "_blank", "noopener,noreferrer");
    }}
  >

  {/* ❤️ Кнопка избранного */}
  <button
    className="favorite-btn"
    onClick={handleToggleFavorite}
    title={isFavorite ? "Αφαίρεση από τα αγαπημένα" : "Προσθήκη στα αγαπημένα"}
  >
    <svg
      className={isFavorite ? "heart-icon filled" : "heart-icon"}
      viewBox="-2 -2 28 28"
      aria-hidden="true"
    >
      <path
        d="M12 22 C12 22 3 14.2 3 8.5 C3 5 5.6 2.5 9 2.5 C11 2.5 12.7 3.6 13.7 5.2 C14.7 3.6 16.4 2.5 18.4 2.5 C21.8 2.5 24 5 24 8.5 C24 14.2 15 22 15 22 C14 23 13 23 12 22 Z"
      />
    </svg>
  </button>
  
    <div className={`ad-card-image-wrap ${imgLoaded ? "is-loaded" : ""}`}>
      <img
        src={imgSrc}
        alt={ad.title}
        className="ad-card-image"
        loading="lazy"
        decoding="async"
        onLoad={() => setImgLoaded(true)}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = "/no-image.png";
          setImgLoaded(true);
        }}
      />
</div>
    <div className="ad-card-content">
      <div className="ad-card-title">{ad.title}</div>
      <div className="ad-card-price">{Number(ad.price).toFixed(2)} €</div>
      <div className="ad-card-location">{ad.location}</div>
    </div>
  </div>
);
};

export default AdCard;
